module.exports = __webpack_public_path__ + "img/title2.7008ff41.png";